import {request, setAuthInHeader} from "@/api/request";
import util from "@/mixins/util";

const state = {
    dongArea: [],
    siArea: [],
};

const getters = {
    getAreaDong: state => state.dongArea,
    getAreaSi: state => state.siArea,
    // v1/area/si(전국 시/도) 응답을 기존 siNameDefine 형태({shortName, daumName, dbName})로 변환.
    // adShortSi=단축명, adSi=정식명. 로드 전/실패 시 siArea가 {}이면 빈 배열 반환하여 소비처가 폴백하도록 함.
    getSiNameDefine: state => {
        if (!Array.isArray(state.siArea)) {
            return [];
        }
        return state.siArea.map(item => ({
            shortName: item.adShortSi,
            daumName: item.adShortSi,
            dbName: item.adSi,
        }));
    },

};

const mutations = {
    updateAreaDong(state, obj) {
        state.dongArea = obj.value;
    },
    resetAreaDong(state) {
        state.dongArea = {};
    },
    updateAreaSi(state, obj) {
        state.siArea = obj.value;
    },
    resetAreaSi(state) {
        state.siArea = {};
    },
};

const actions = {
    setAreaDong({commit, rootState}) {
        if(state.dongArea.length > 0) {
            return;
        }
        request.javaGet('v1/area/dong').then((res) => {
            let result = res.data;
            if (result.code > 0 && !util.isEmpty(result.result.list)) {
                commit('updateAreaDong', {'value': result.result.list});
            } else {
                commit('updateAreaDong', {'value': {}})
            }
        }, () => {
            console.log('error');
        })
    },
    changeAreaDong({commit, rootState}, {data}) {
        commit('updateAreaDong', {'value': data});
    },
    initAreaDong({commit, rootState}, {data}) {
        commit('resetAreaDong');
    },
    setAreaSi({commit, rootState}) {
        if(state.siArea.length > 0) {
            return;
        }
        request.javaGet('v1/area/si')
            .then((res) => {
                let result = res.data;
                if (result.code > 0 && !util.isEmpty(result.result.list)) {

                    commit('updateAreaSi', {'value': result.result.list});
                } else {
                    commit('updateAreaSi', {'value': {}})
                }
            }, () => {
                console.log('error');
            })
    },
    changeAreaSi({commit, rootState}, {data}) {
        commit('updateAreaSi', {'value': data});
    },
    initAreaSi({commit, rootState}, {data}) {
        commit('resetAreaSi');
    },

};

export default {namespaced: true, state, getters, mutations, actions}
